import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';
import UserDeleteConfirmOverlay from '../../components/users/UserDeleteConfirmOverlay';
import { deleteUser, getOrgUsers, getUserById } from '~/apps/shared/actions/users';
import Loader from '~/common/components/Loader';
import { defaultTablePageSize } from '~/common/components/consts';


class ConfirmUserPopup extends React.Component<any, any> {

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getUserById(this.props.userId));
  }

  deleteUser = () => {
    const { dispatch, auth, userId } = this.props;
    const orgId = auth.currentUser.organizationId;

    return dispatch(deleteUser(userId))
      .then(() => {
        dispatch(getOrgUsers(null, 0, defaultTablePageSize));
        this.onClose();
      });
  };

  onClose = () => {
    navigate('pos.admin.settings.team');
  };

  render() {
    const { users, userId,  title } = this.props;
    const user = users.entities[userId];

    if (!user || users.ui.loading) {
      return (
        <Loader className="load--ol" />
      );
    }

    return (
      <UserDeleteConfirmOverlay
        headTitle={title}
        onDelete={this.deleteUser}
        onClose={this.onClose}
        user={user}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.shared.auth,
    organizations: state.shared.organizations,
    users: state.shared.users
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmUserPopup) as any;
